export default "__VITE_ASSET__212e2bdc__"